import { createStore, createEvent, createEffect, combine } from 'effector';
import { get } from 'lodash';

import request from '@helpers/request';
import api from '@constants/endpoints';
import createPreloadersStore from './preloaders';

export interface IUserSuspiciousChat {
  id?: string | number;
  chatId?: string | number;
  messageId?: string | number;
  created?: string;
  createdAt?: string;
  messageCreatedAt?: string;
  comment?: string;
  text?: string;
  messageText?: string;
  nickname?: string;
  reason?: string;
  type?: string;
  [key: string]: unknown;
}

export const reset = createEvent('User suspicious chats reset');

export const getList = createEffect({
  name: 'getUserSuspiciousChats',
  async handler(accountId: string) {
    const response = await request(api.spam.getUserSuspiciousChats, {
      urlParams: {
        accountId,
      },
      data: {
        pagination: {
          page: 0,
          pageSize: 10,
          type: 'PAGE',
        },
      },
    });

    return response;
  },
});

const preloaders = createPreloadersStore([getList]);

const toSuspiciousChatsList = (value: unknown): IUserSuspiciousChat[] => {
  if (!Array.isArray(value)) return [];

  return value as IUserSuspiciousChat[];
};

const getResultList = (result: unknown): IUserSuspiciousChat[] => {
  const data = get(result, ['data', 'body', 'result'], []) as unknown;

  if (Array.isArray(data)) return toSuspiciousChatsList(data);

  const pagedData = data as {
    page?: unknown;
    content?: unknown;
    result?: unknown;
  };

  const list = [pagedData.page, pagedData.content, pagedData.result].find(Array.isArray);

  return toSuspiciousChatsList(list);
};

const list = createStore<IUserSuspiciousChat[]>([])
  .on(getList.done, (_, { result }) => getResultList(result))
  .reset(reset);

const userSuspiciousChats = combine({
  preloaders,
  list,
});

export default userSuspiciousChats;
